<style lang="scss" scoped>
    .divider {
        margin: 120px 30% 0 30%;
    }

    .articles {
        width: 948px;
        margin: 20px auto 0 auto;
        list-style: none;
        padding: 0;
        position: relative;
    }

    .btn-change {
        text-align: center;
        margin-top: 30px;
        margin-bottom: 120px;
    }
</style>

<template>
    <div>
        <div class="ui horizontal divider">文章·热门</div>
        <ul class="articles">
            <bcms-cell v-for="article in articles"
                       :key="article.url_alias"
                       :cover="article.cover"
                       :title="article.title"
                       :author="article.author"
                       :subject="article.subject"
                       :url="article.url"
            />
        </ul>
        <div class="btn-change">
            <button class="ui basic black button mini" @click="changePage">换一批</button>
        </div>
    </div>
</template>

<script>
    import 'semantic-ui-divider/divider.min.css';
    import 'semantic-ui-button/button.min.css';
    import axios from 'axios';
    import BcmsCell from '../article/card.vue';

    export default {
        data() {
            return {
                articles: []
            }
        },
        components: {
            BcmsCell,
        },
        methods: {
            changePage() {
                axios.get('/a')
                    .then((response) => {
                        this.articles = response.data.data;
                    })
                    .catch((errors) => {
                        alert("网络错误，请检查！");
                        console.error(errors);
                    });
            }
        },
        mounted() {
            this.changePage();
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/web/components/index/articles.vue